import React from "react";
import TextInput from "../../../../components/inputs/TextInput";
import DetailItem from "./DetailItem"; 
import style from "./ClientInfo.module.scss";
import { useTranslation } from "react-i18next";

const ClientInfo = ({ client, isEditing, onClientChange }) => {
  const { t } = useTranslation();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onClientChange((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={style.clientCard}>
      {isEditing ? (
        <>
          <TextInput label={t("clientInfo.fullName")} name="fullname" value={client.fullname || ""} onChange={handleInputChange} placeholder={t("clientInfo.enterFullName")} />
          <TextInput label={t("clientInfo.phone")} name="phone_number" value={client.phone_number || ""} onChange={handleInputChange} placeholder={t("clientInfo.enterPhone")} />
          <TextInput label={t("clientInfo.email")} name="email" value={client.email || ""} onChange={handleInputChange} placeholder={t("clientInfo.enterEmail")} />
          <TextInput label={t("clientInfo.passportNumber")} name="passport_number" value={client.passport_number || ""} onChange={handleInputChange} placeholder={t("clientInfo.enterPassportNumber")} />
        </>
      ) : (
        <div className={style.detailsGrid}>
          <DetailItem label={t("clientInfo.fullName")} value={client.fullname} />
          <DetailItem label={t("clientInfo.phone")} value={client.phone_number} />
          <DetailItem label={t("clientInfo.email")} value={client.email} />
          <DetailItem label={t("clientInfo.passportNumber")} value={client.passport_number} />
          <DetailItem label={t("clientInfo.createdAt")} value={new Date(client.created_at).toLocaleDateString()} />
        </div>
      )}
    </div>
  );
};

export default ClientInfo;
